import React from 'react';

interface DateFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export function DateFilter({ value, onChange }: DateFilterProps) {
  return (
    <div className="retro-card p-4 md:p-6 mb-6">
      <div className="index-tab">
        <h3 className="text-lg font-semibold text-text-dark">Time Range Filter</h3>
      </div>
      <div className="p-3 md:p-4">
        <label htmlFor="dateFilter" className="sr-only">
          Select time range for meal logs
        </label>
        <select 
          id="dateFilter"
          value={value} 
          onChange={(e) => onChange(e.target.value)}
          className="vintage-input w-full max-w-md text-sm md:text-base"
          aria-describedby="dateFilter-help"
        >
          <option value="today">Today</option>
          <option value="week">This Week</option>
          <option value="month">This Month</option>
          <option value="all">All Time</option>
        </select>
        <p id="dateFilter-help" className="text-xs text-text-medium mt-1">
          Filter meal logs by time range
        </p>
      </div>
    </div>
  );
} 